<template>
  <x-page title="我的评价" :loading="loading" :white-background="true">
    <div v-if="!loading" class="evaluation-list">
      <div class="userInfo">
        <img :src="userInfo.avatar" alt="" />
        <p>{{ userInfo.userName || userInfo.phoneNum }}</p>
      </div>
      <ul class="title">
        <li
          v-track="{
            name: '我的评价-已评价',
            id: 'cbcca5de-1213-44ec-a0a6-41ed35c77aa9',
          }"
          :class="{ active: !params.havingAddEvaluate }"
          @click="filterChange(0, null)"
        >
          已评价
        </li>
        <li
          v-track="{
            name: '我的评价-追评',
            id: 'c6d4ecc4-5ab1-4881-bef0-86b7c2b14b4f',
          }"
          :class="{ active: params.havingAddEvaluate }"
          @click="filterChange(1, null)"
        >
          追评
        </li>
      </ul>
      <div class="ribbon"></div>

      <x-waterfall ref="list" :load="load">
        <template #default="{ data }">
          <com-evaluation-item
            v-for="item in data"
            :key="item.id"
            class="list-item van-hairline--bottom"
            :item="item"
          />
        </template>
      </x-waterfall>
    </div>
  </x-page>
</template>

<script>
  import ComEvaluationItem from './components/comment'
  import {
    apiEvaluationEvaluateGetUserEvaluateList,
    apiPageConfigUserBaseInfo,
  } from '@/api'
  import { Track } from '@/utils'

  export default {
    noKeepalive: true,
    components: { ComEvaluationItem },
    mixins: [
      Track.provideMark(() => ({
        page: '全部评价',
      })),
    ],
    data() {
      return {
        labelList: [],
        loading: true,
        params: {
          havingAddEvaluate: 0, //是否只显示有追评 0否1是
          havingPicFlag: 0,
        },
        userInfo: {},
      }
    },
    mounted() {
      this.getUserInfo()
    },
    methods: {
      async getUserInfo() {
        const data = await apiPageConfigUserBaseInfo()
        this.userInfo = data
        this.loading = false
      },
      filterChange(havingAddEvaluate) {
        this.params.havingAddEvaluate = havingAddEvaluate
        this.$reloadWaterfall('list')
      },
      load({ pageNumber }) {
        return apiEvaluationEvaluateGetUserEvaluateList({
          pageIndex: pageNumber,
          pageSize: 15,
          ...this.params,
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .evaluation-list {
    background: #ffffff;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .userInfo {
      display: flex;
      align-items: center;
      padding-left: 12px;
      img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        margin-right: 12px;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #222222;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }
    }

    > .title {
      margin-top: 16px;
      display: flex;
      flex-wrap: wrap;
      padding-left: 13px;
      padding-bottom: 9px;
      background-color: white;

      position: sticky;
      top: 0;
      z-index: 9;

      li {
        height: 24px;
        background: #f5f6f8;
        border-radius: 12px;

        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 24px;
        padding: 0 10px;
        margin-right: 8px;
        margin-bottom: 8px;

        &.active {
          color: #ff111c;
          background: #fff2f1;
        }
      }
    }

    > .ribbon {
      position: relative;
      height: 10px;
      background: #eeeeee;
      z-index: 8;
    }

    .list-item {
      padding: 15px 12px 18px;

      &:after {
        margin-left: 24px;
        margin-right: 24px;
      }

      ::v-deep .evaluation-item-user {
        margin-top: 0;
      }
    }

    .van-list {
      min-height: calc(100vh - var(--nav-bar-height) - 67px);
    }
  }
</style>
